import * as React from "react";

function Instagram(props) {
  return (
    <svg
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      aria-label="Instagram logo"
    >
      <circle
        cx={15}
        cy={15.005}
        r={15}
        fill="url(#prefix__paint0_linear_116_64)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 5.005c-2.716 0-3.056.011-4.123.06-1.064.049-1.791.218-2.427.465a4.902 4.902 0 00-1.772 1.153 4.901 4.901 0 00-1.153 1.771c-.247.637-.416 1.364-.465 2.428-.048 1.066-.06 1.407-.06 4.123s.012 3.056.06 4.123c.049 1.064.218 1.791.465 2.427a4.902 4.902 0 001.153 1.771A4.902 4.902 0 008.45 24.48c.636.247 1.363.416 2.427.465 1.067.048 1.407.06 4.123.06s3.056-.012 4.123-.06c1.064-.049 1.791-.218 2.427-.465a4.902 4.902 0 001.772-1.154 4.902 4.902 0 001.153-1.77c.247-.637.416-1.364.465-2.428.048-1.067.06-1.407.06-4.123s-.012-3.057-.06-4.123c-.049-1.064-.218-1.791-.465-2.428a4.902 4.902 0 00-1.153-1.77A4.902 4.902 0 0021.55 5.53c-.636-.247-1.363-.416-2.427-.465-1.067-.049-1.407-.06-4.123-.06zm0 1.802c2.67 0 2.986.01 4.04.058.976.044 1.505.207 1.858.344.466.182.8.398 1.15.748.35.35.566.683.748 1.15.137.353.3.882.344 1.857.048 1.054.058 1.37.058 4.04 0 2.671-.01 2.987-.058 4.042-.045.975-.207 1.504-.344 1.857-.182.466-.398.8-.748 1.15-.35.35-.683.566-1.15.747-.353.137-.882.3-1.857.345-1.054.048-1.37.058-4.041.058-2.67 0-2.986-.01-4.04-.058-.976-.045-1.505-.208-1.858-.345a3.097 3.097 0 01-1.15-.748 3.098 3.098 0 01-.748-1.15c-.137-.352-.3-.881-.344-1.856-.048-1.055-.058-1.371-.058-4.041 0-2.67.01-2.987.058-4.041.045-.975.207-1.504.344-1.857.182-.467.399-.8.748-1.15.35-.35.684-.566 1.15-.748.353-.137.882-.3 1.857-.344 1.055-.048 1.37-.058 4.041-.058z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 18.338a3.333 3.333 0 110-6.667 3.333 3.333 0 010 6.667zm0-8.468a5.135 5.135 0 100 10.27 5.135 5.135 0 000-10.27zM21.538 9.667a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0"
        fill="#fff"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_116_64"
          x1={15}
          y1={45.005}
          x2={45}
          y2={15.005}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD522" />
          <stop offset={0.497} stopColor="#F1000B" />
          <stop offset={1} stopColor="#B900B3" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Instagram;